jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});



    // Select the overlay element
    const overlay = document.querySelector('.t4s-close-overlay2');

    // Select all menu item elements
    const menuItems = document.querySelectorAll('.menu-width__full');

    // Function to add the is--visible class
    function showOverlay() {
      overlay.classList.add('is--visible');
    }

    // Function to remove the is--visible class
    function hideOverlay() {
      overlay.classList.remove('is--visible');
    }

    // Add event listeners to each menu item
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', showOverlay);
      item.addEventListener('mouseleave', hideOverlay);
    });
